import { Component, OnInit } from '@angular/core';

/**
 * Componente indicador de carga alternativo (segunda variante de spinner)
 * usado para señalar procesos en segundo plano.
 */
@Component({
  selector: 'app-loader2',
  templateUrl: './loader2.component.html',
  styleUrls: ['./loader2.component.css']
})
export class Loader2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
